// extracted by mini-css-extract-plugin
export default {"button":"NRtoyGwxYbmQc0931CnNew=="};